var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCashbook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3C1.90694 3 1 3.90694 1 5V19C1 20.0931 1.90694 21 3 21H21C22.0931 21 23 20.0931 23 19V5C23 3.90694 22.0931 3 21 3H3ZM3 8H11V19H3V8ZM13 8H21V19H13V8ZM6 11C5.448 11 5 11.448 5 12C5 12.552 5.448 13 6 13H8C8.552 13 9 12.552 9 12C9 11.448 8.552 11 8 11H6ZM16 11C15.448 11 15 11.448 15 12C15 12.552 15.448 13 16 13H18C18.552 13 19 12.552 19 12C19 11.448 18.552 11 18 11H16ZM6 15C5.448 15 5 15.448 5 16C5 16.552 5.448 17 6 17H7C7.552 17 8 16.552 8 16C8 15.448 7.552 15 7 15H6ZM16 15C15.448 15 15 15.448 15 16C15 16.552 15.448 17 16 17H17C17.552 17 18 16.552 18 16C18 15.448 17.552 15 17 15H16Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCashbook);
export default __webpack_public_path__ + "static/media/ic_cashbook.ceffc613d80a753437cc48912ba061c5.svg";
export { ForwardRef as ReactComponent };